/* ===========================
IMPORTS
=========================== */
import React from 'react';
// IMPORT - ELEMENTS
import Loader from './Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class Footer extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
   */
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
    };
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    Footer.request(
      (response) => {
        if (response.version) {
          this.setState({
            data: response,
            loading: false,
          });
        } else {
          this.setState({
            loading: false,
          });
        }
      },
    );
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {function} callback
   * @param {function} failback
   */
  static request(callback, failback) {
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <footer>
        <div className="container-fluid">
          {(this.state.loading)
            ? (
              <div className="row">
                <div className="col">
                  <Loader />
                </div>
              </div>
            )
            : (
              <div className="row">
                <div className="col col-6">
                  Backend Version:
                  {' '}
                  {(Object.keys(this.state.data).length > 0 && this.state.data.version) ? this.state.data.version : ''}
                </div>
                <div className="col col-6">
                  Frontend Version:
                  {' '}
                  {process.env.REACT_APP_COMMIT_SHA}
                </div>
              </div>
            )}
        </div>
      </footer>
    );
  }
}

/* ===========================
EXPORT
=========================== */
export default Footer;
